import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import Notify from 'react-notification-alert';
import {request} from "../../helper/APIUtils";
import SingleFileSigner from "./component/SingleFileSigner"
import ReactLoading from 'react-loading';
import {SERVLET_PATH} from '../../constants'
import EdefterApplicationModal from "../../components/EdefterApplicationModal";

var base64_arraybuffer = require('base64-arraybuffer')

class ApplicationSigner extends Component {

  constructor() {
    super();
    this.state = {
      initialized: false,
      sorumluFieldsValid : true,
      edefterApplicationModal: false,
      customer: null,
    };

    this.init = this.init.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.signCompleted = this.signCompleted.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.checkContactPersonInfo = this.checkContactPersonInfo.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    let params = {
			url: '/signature/application/nextApplication',
			method: "get"
    };

    this.setState({
      loading: true
    });
    
    request(params).then(response => {

      let url;
      let sorumluFieldsValid = true;
      let customer;

      if (response.data.value && response.data.customer) {

        customer = response.data.customer;
        sorumluFieldsValid = this.checkContactPersonInfo(customer);

        let contractArr = new Uint8Array(base64_arraybuffer.decode(response.data.value));
        let blob = new Blob( [ contractArr ], { type: "application/pdf" } );
        let urlCreator = window.URL || window.webkitURL;
        url = urlCreator.createObjectURL(blob);
      }

      this.setState({
        loading: false,
        contract: response.data,
        contractUrl: url,
        initialized: true,
        edefterApplicationModal: !sorumluFieldsValid,
        customer
      });

      if (!response.data) {
        this.nextPage();
      }
    });
  }

  checkContactPersonInfo(customer){
    if(!customer){
      return false;
    }else if( (!customer.sorumluTckn || customer.sorumluTckn && customer.sorumluTckn === "") ||
        (!customer.sorumluAd || customer.sorumluAd && customer.sorumluAd === "") ||
        (!customer.sorumluSoyad || customer.sorumluSoyad && customer.sorumluSoyad === "") ||
        (!customer.sorumluCepTel || customer.sorumluCepTel && customer.sorumluCepTel === "") ||
        (!customer.sorumluEPosta || customer.sorumluEPosta && customer.sorumluEPosta === "")){
      return false;
    }else{
      return true;
    }
  }

  nextPage() {
    if (this.props.currentUser.gibEDefterApplicationRequired) {
      this.props.history.push("/signature/edefterApplication");
    } else if (this.props.currentUser.contractSignatureRequired) {
      this.props.history.push("/signature/contract");
    } else if (this.props.currentUser.aliasSignatureRequired) {
      this.props.history.push("/signature/alias");
    } else {
      setTimeout(function () {
        window.location.href = SERVLET_PATH + "/";
      }, 100);
    }
  }

  signCompleted(param) {

    let params = {
			url: '/signature/application/writeSignedApplication',
      method: "post",
      data: {
        uuid: this.state.contract.uuid,
        value: param.signedDocument
      }
    };

    return request(params);
  }

  onComplete() {
    this.setState({
      loading: false,
      contract: null,
      contractUrl: null,
      initialized: false
    });

    this.nextPage();
  }

  renderContractExplanation() {
    return this.state.contract && <Alert color="info">
      Aşağıdaki sözleşmenin imzalanması gerekmektedir. Akıllı kartınızı takınız ve sözleşmeyi imzalayınız.
    </Alert>
  }

  renderNoDataExplanation() {
    return this.state.initialized && !this.state.contract && <Alert color="success">
      İmzalanacak sözleşme bulunmamaktadır.
    </Alert>
  }

  renderContract() {
    return this.state.contractUrl && <iframe src={this.state.contractUrl} style={{width: "100%", height: "500px"}}/>
  }

  renderSigner() {
    return this.state.contract && <SingleFileSigner currentUser={this.props.currentUser} pdf={true} document={this.state.contract.value} signCompleted={this.signCompleted} omitXmlDeclaration={true} onComplete={this.onComplete}/>
  }

  render() {
    return (
      <div className="row">
        <Notify ref="notify"/>
        {this.state.alert}
				<div className="col-md-12">
					<div className="card">
						<div className="card-header ">
							<h4 className="card-title">GİB Başvurusu İmzala</h4>
						</div>
						<div className="card-body">
              {!this.state.loading && this.renderNoDataExplanation()}
              {!this.state.loading && this.renderContractExplanation()}
              {!this.state.loading && this.renderContract()}
              <br />
              {!this.state.loading && this.renderSigner()}
              {this.state.loading && <ReactLoading type="spinningBubbles" style={{width:"100px", height: "100px", margin: "100px auto 100px auto", fill: "#888"}}/>}
						</div>
					</div>
                </div>
        {this.state.edefterApplicationModal &&
        <EdefterApplicationModal
            currentUser = {this.props.currentUser}
            edefterApplicationModal = {this.state.edefterApplicationModal}
            close = {() =>  this.setState({edefterApplicationModal: false})}
            cancel = {() => this.setState({edefterApplicationModal: false})}
            customer = {this.state.customer}
            showBody = {false}
            cancellable = {false} />
        }
      </div>
    );
  }
}

export default ApplicationSigner;
